/**
 * Dicas que aparecem ao parar o mouse sobre um campo ou botão.
 * A chave é o texto do rótulo/botão (sem acento, minúsculo). Para uma dica específica,
 * use `data-ajuda="texto"` no próprio elemento: ela tem prioridade sobre esta lista.
 */
export const DICAS: Record<string, string> = {
  // Estoque
  placa:
    'Placa do carro (Mercosul ou antiga). Com ela o sistema busca dados e evita cadastro repetido.',
  'preco de venda':
    'Valor anunciado no site e nos portais. Pode ser mudado a qualquer momento; o histórico fica guardado.',
  preco: 'Valor anunciado no site e nos portais.',
  fipe: 'Preço médio de mercado pela tabela FIPE, para comparar com o seu preço.',
  km: 'Quilometragem no painel do carro.',
  'valor de compra': 'Quanto a loja pagou pelo carro. Só dono, gerente e financeiro veem.',
  'custo total': 'Compra + preparação + despesas lançadas no carro. Base da margem.',
  'margem prevista':
    'Preço de venda menos o custo total. Quanto sobra se vender pelo preço anunciado.',
  'dias em estoque': 'Desde a entrada do carro. Acima de 60 dias o carro aparece como parado.',
  'salvar carro': 'Grava o carro. Ele só aparece no site quando o status for "À venda".',
  'novo carro': 'Cadastrar um carro que entrou na loja.',
  'importar planilha': 'Trazer vários carros de uma vez a partir de uma planilha do Excel.',
  'exportar csv': 'Baixa a lista do filtro atual em planilha (abre no Excel).',
  exportar: 'Baixa a lista do filtro atual em planilha (abre no Excel).',
  'carregar mais': 'Mostra os próximos 20 itens da lista.',
  status: 'Situação atual (à venda, em preparação, reservado, vendido...).',
  marca: 'Fabricante do carro. Use para filtrar a lista.',
  buscar: 'Procure por placa, marca, modelo ou nome.',
  // Venda e pagamentos
  'registrar venda':
    'Fecha a venda: tira o carro do estoque, gera o contrato e lança os pagamentos.',
  vender: 'Fecha a venda: tira o carro do estoque, gera o contrato e lança os pagamentos.',
  entrada: 'Valor pago na hora. O resto pode ser financiado ou parcelado no crediário.',
  'forma de pagamento':
    'Pix, dinheiro, cartão, crediário da loja ou financiamento. Pode misturar várias.',
  crediario: 'Parcelado pela própria loja. O sistema manda o Pix de cada parcela e avisa atrasos.',
  financiamento: 'Pago pelo banco. A loja recebe do banco; o cliente paga as parcelas ao banco.',
  parcelas: 'Em quantas vezes. O valor de cada parcela é calculado pela Tabela Price.',
  'primeiro vencimento': 'Data da 1ª parcela. As outras vencem no mesmo dia dos meses seguintes.',
  maquininha: 'Cadastre as taxas da sua maquininha para o sistema descontar do valor recebido.',
  'taxa mensal': 'Juros ao mês, em %. Ex.: 1,99.',
  multa: 'Percentual cobrado uma vez quando a parcela atrasa (máx. 2% por lei).',
  'juros de mora': 'Juros por dia de atraso, proporcionais ao mês (máx. 1% ao mês).',
  // Financeiro
  vencimento: 'Data limite para pagar ou receber.',
  competencia: 'Mês a que a despesa ou receita pertence (para o resultado do mês).',
  categoria: 'Tipo do lançamento (aluguel, comissão, venda...). Organiza os relatórios.',
  conta: 'De qual conta o dinheiro sai ou entra (caixa, banco...).',
  'dar baixa': 'Marca como pago/recebido e lança no caixa ou banco escolhido.',
  baixar: 'Marca como pago/recebido e lança no caixa ou banco escolhido.',
  'fechar caixa': 'Confere o dinheiro do dia com o que o sistema calculou e registra a diferença.',
  'abrir caixa': 'Começa o dia informando o dinheiro que já está na gaveta.',
  'nova conta': 'Lançar algo a pagar ou a receber.',
  recibo: 'Gera o recibo em PDF para imprimir ou mandar ao cliente.',
  // Clientes e CRM
  nome: 'Nome completo, como no documento.',
  cpf: 'Só números. Fica criptografado e é usado no contrato e na nota.',
  telefone: 'Com DDD. Usado para WhatsApp (só se o cliente aceitar receber mensagens).',
  'e-mail': 'Para enviar contrato, recibo e lembretes de parcela.',
  email: 'Para enviar contrato, recibo e lembretes de parcela.',
  consentimento:
    'O cliente aceitou receber mensagens. Sem isso o sistema não manda WhatsApp (LGPD).',
  origem: 'De onde o cliente veio (site, portal, indicação...). Mostra quais canais vendem mais.',
  vendedor: 'Responsável pelo atendimento. Recebe os avisos e a comissão.',
  observacoes: 'Anotações internas. O cliente não vê.',
  'novo lead': 'Registrar um interessado que chegou por telefone ou na loja.',
  'agendar test drive': 'Marca horário com o cliente. Multa nesse horário vai para ele.',
  // Contratos e documentos
  'gerar contrato': 'Cria o contrato em PDF com os dados da venda e do cliente.',
  'assinar pelo celular':
    'Manda um link para o cliente assinar no celular, com código de verificação.',
  'enviar link': 'Envia o link de assinatura para o cliente.',
  cnh: 'Documento com foto do cliente, exigido antes da assinatura à distância.',
  'comprovante de residencia': 'Conta de luz, água ou similar, dos últimos 3 meses.',
  // Eventos
  'novo evento':
    'Feirão ou promoção: escolha os carros, o preço especial e acompanhe gasto e lucro.',
  'preco promocional': 'Preço durante o evento. Volta ao normal sozinho quando o evento acaba.',
  orcamento:
    'Quanto pretende gastar com o evento (anúncio, brindes...). Compara com o lucro no fim.',
  // Multas
  'auto de infracao': 'Número que vem na notificação da multa.',
  'data e hora':
    'Do momento da infração. Define se a multa é da loja, do comprador ou do test drive.',
  repassar: 'Cobra a multa do responsável (cliente ou dono anterior).',
  // Geral
  salvar: 'Grava as alterações.',
  cancelar: 'Fecha sem salvar.',
  excluir: 'Apaga o item. Algumas exclusões não podem ser desfeitas.',
  filial: 'Qual loja da rede. Cada filial tem estoque e caixa próprios.',
  ajuda: 'Central de ajuda: artigos, novidades e abrir um chamado com a gente.',
};

const normalizar = (t: string) =>
  t
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[*:?()]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

export function dicaPara(texto: string | null | undefined): string | null {
  if (!texto) return null;
  const k = normalizar(texto);
  if (k.length > 40) return null;
  return DICAS[k] ?? null;
}
